import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Config } from '../api/types';
import config from '../config';
import { Duration } from '../constants';

async function getConfig(axios: AxiosInstance): Promise<Config> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/utilities/config`);

  return data;
}

export default function useConfigQuery() {
  const axios = useAxios();
  const toast = useToast();
  const navigate = useNavigate();

  const query = useQuery({
    queryKey: getKey(),
    queryFn: () => getConfig(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    gcTime: Duration.Hour * 10,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as any;

      if (error?.response?.status !== 503) {
        manageErrorResponse(toast, error);
      }
      if (error?.response?.status >= 500 && error?.response?.status !== 503) {
        navigate('/app/errorPage', { replace: true });
      }
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['Config'] as const satisfies QueryKey;
}

useConfigQuery.getKey = getKey();
